// extracted by mini-css-extract-plugin
export default {"page":"createBusiness_page__20ryB","mobilePage":"createBusiness_mobilePage__mdNqd","leftSide":"createBusiness_leftSide__8vHKp","rightSide":"createBusiness_rightSide__CYW-p"};